<template>
  <subAccountCommonDialog class="sub-account-password-dialog" :visible.sync="visible" title="修改密码" @clickCancel="clickCancel" @clickConfirm="clickConfirm">
    <template v-slot:dialogContent>
      <span class="title">新密码：</span>
      <el-input v-model="inputValue" size="mini" placeholder="8-24位密码，字母、数字、下划线至少包含两种"></el-input>
    </template>
  </subAccountCommonDialog>
</template>
<script>
import subAccountCommonDialog from './subAccountCommonDialog.vue'
export default {
  name: 'subAccountPasswordDialog',
  props: ['visible'],
  data() {
    return {
      inputValue: null,
      message: '请输入8-24位密码，字母、数字、下划线至少包含两种'
    }
  },
  methods: {
    clickCancel() {
      this.$emit('clickCancel')
    },
    clickConfirm() {
      if (this.checkPassword()) {
        this.$emit('clickConfirm', this.inputValue)
      } else {
        this.$alert(this.message, '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    checkPassword() {
      var passWd = /^(?![0-9]+$)(?![a-zA-Z]+$)(?![_]+$)[0-9A-Za-z_]{8,24}$/
      return passWd.test(this.inputValue)
    }
  },
  components: {
    subAccountCommonDialog
  }
}
</script>
<style lang="scss" scoped>
.sub-account-password-dialog {
  .title {
    color: #000;
  }
  /deep/ .el-input {
    width: 300px;
  }
}
</style>
